export const LOGIN_LOCALE_MAPPER = {
    en: 'en-US',
    de: 'de-DE',
  }